<nav class="w-full flex justify-content-between align-items-center py-0" aria-label="Navigation Bar">
  <button class="seal-link navbar-brand pb-0">
    <img ngSrc="assets/img/seal-and-title.svg" class="seal-and-title mr-2" alt="FEC Seal" height="48" width="227" />
  </button>

  <div class="collapse navbar-collapse justify-content-end" id="navbarTogglerDemo01">
    <app-header-links [headerStyle]="headerStyle"></app-header-links>
  </div>
</nav>
